import { useMemo } from "react";

import { useSwrFetch } from "./useSwrFetch";

interface QuoteCountResponse {
  quote_count: number;
}

export function useShipmentQuoteCount(shipmentId: number) {
  const url = useMemo(
    () => (shipmentId !== 0 ? `/shipments/${shipmentId}/quote-count` : null),
    [shipmentId],
  );

  const {
    data,
    loading,
    error,
    refetch: refetchQuoteCount,
  } = useSwrFetch<QuoteCountResponse>({
    url,
    errorMessage: "Failed to fetch quote count",
  });

  return {
    quoteCount: data?.quote_count ?? null,
    isLoading: loading,
    error,
    refetchQuoteCount,
  };
}
